/**
 * For every search box: no browser predictions. Chrome ignores `autocomplete="off"` on a field it takes for an
 * address (and "Business, site or town" reads like one), but it doesn't autofill a search input, so the type
 * does the work; `autocomplete="off"` stops its history of past entries. The results a box shows are its own.
 */
export const SEARCH_INPUT_PROPS = {
  type: 'search',
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
} as const;
